import { useQuery, keepPreviousData } from '@tanstack/react-query';

import { options } from './query-options';

import type { Exchange } from '@/entities/market/types/exchange';
import type { MarketType, MarketCandleRange } from '@shared';

export const useSelectMarketsQuery = (marketType: MarketType) => useQuery(options.selectFilteredMarkets(marketType));

export const useMarketCandlesMinuteQuery = (market: string, range: MarketCandleRange) =>
  useQuery(options.getMarketCandlesWithUnit({ market, range }));

export const useMarketTickerQuery = (market: string, queryOptions?: { enabled?: boolean }) =>
  useQuery({
    ...options.getMarketTicker(market),
    enabled: (queryOptions?.enabled ?? true) && Boolean(market),
  });

export const useMarketTickersQuery = (markets: string[]) => useQuery(options.getMarketTickers(markets));

// --- 멀티 거래소 ---

export const useSelectMarketsByExchangeQuery = (exchange: Exchange, marketType: MarketType) =>
  useQuery({ ...options.selectFilteredMarketsByExchange(exchange, marketType), placeholderData: keepPreviousData });

// TRAD-3752 — 거래소의 전체 마켓 목록(필터 없음). 상세의 «파라미터 없을 때 거래소 고르기»용.
// 🔴 keepPreviousData 를 쓰지 않는다 — 키가 바뀌는 동안 «다른 거래소의 목록»을 보여 주면 상장 판정이 틀린다.
export const useMarketsByExchangeQuery = (exchange: Exchange, enabled = true) =>
  useQuery({ ...options.getMarketsByExchange(exchange), enabled });

export const useMarketTickersByExchangeQuery = (exchange: Exchange, markets: string[]) =>
  useQuery({ ...options.getMarketTickersByExchange(exchange, markets), placeholderData: keepPreviousData });

// --- 도미넌스 ---

export const useDominanceQuery = () => useQuery(options.getDominance());
